module.exports = __webpack_public_path__ + "media/images/gift-thanks-modal-bg-candy@3x-72a1f11a72550921db5cd0f8deec7013.png";